import React from 'react';
import { useGroupState } from './GroupContext';

import styles from './GroupProfilePicture.module.scss';

const GroupProfilePicture = () => {
  const state = useGroupState();

  if (state?.loading) {
    return (
      <section id={styles.groupProfilePictureSection}>
        <div id={styles.groupProfilePictureLoading} />
      </section>
    );
  }

  return (
    <section id={styles.groupProfilePictureSection}>
      <img
        id={styles.groupProfilePicture}
        src={state.group?.imagePath}
        alt={`${state?.group?.name} profile`}
      />
    </section>
  );
};

export default GroupProfilePicture;
